var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import ReactPlayer from 'react-player/lazy';
import { sendWebsocketMessage } from '../../helpers/websocket';
import { store, useAppSelector } from '../../store';
import { createSelector } from '@reduxjs/toolkit';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../helpers/proto/plugnmeet_datamessage_pb';
const heightSelector = createSelector(_react_refresh_temp_1 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.screenHeight);
$RefreshReg$(_react_refresh_temp_1, "heightSelector$createSelector");
const widthSelector = createSelector(_react_refresh_temp_2 = (state) => state.bottomIconsActivity, (bottomIconsActivity) => bottomIconsActivity.screenWidth);
$RefreshReg$(_react_refresh_temp_2, "widthSelector$createSelector");
const ReactPlayerComponent = ({ src, action, seekTo, isPresenter, }) => {
    _react_refresh_temp_4();
    const [paused, setPaused] = useState(true);
    const [isReady, setIsReady] = useState(false);
    const [playing, setPlaying] = useState(false);
    const player = useRef();
    const session = store.getState().session;
    const height = useAppSelector(heightSelector);
    const width = useAppSelector(widthSelector);
    useEffect(() => {
        if (isPresenter) {
            return;
        }
        if (action === 'play') {
            setPlaying(true);
        }
        else if (action === 'pause') {
            setPlaying(false);
        }
    }, [action, isPresenter]);
    useEffect(() => {
        var _a;
        if (!isReady) {
            return;
        }
        if (!isPresenter && seekTo > 1 && player) {
            (_a = player.current) === null || _a === void 0 ? void 0 : _a.seekTo(seekTo);
        }
    }, [seekTo, player, isReady, isPresenter]);
    useEffect(() => {
        var _a;
        if (!isPresenter) {
            return;
        }
        if (!isReady || !player) {
            return;
        }
        const broadcast = (msg) => {
            var _a, _b, _c, _d;
            const dataMsg = new DataMessage({
                type: DataMsgType.SYSTEM,
                roomSid: session.currentRoom.sid,
                roomId: session.currentRoom.room_id,
                body: {
                    type: DataMsgBodyType.EXTERNAL_MEDIA_PLAYER_EVENTS,
                    from: {
                        sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                        userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                    },
                    msg,
                },
            });
            sendWebsocketMessage(dataMsg.toBinary());
        };
        if (paused) {
            const msg = {
                action: 'pause',
            };
            broadcast(JSON.stringify(msg));
        }
        else {
            const msg = {
                action: 'play',
                seekTo: (_a = player.current) === null || _a === void 0 ? void 0 : _a.getCurrentTime(),
            };
            broadcast(JSON.stringify(msg));
        }
    }, [isReady, paused, player, isPresenter]);
    const onReady = () => {
        setIsReady(true);
    };
    const onPause = () => {
        setPaused(true);
    };
    const onPlay = () => {
        setPaused(false);
    };
    const ref = (_player) => {
        player.current = _player;
    };
    return (_jsx(_Fragment, { children: _jsx(ReactPlayer, { ref: ref, url: src, width: width * 0.7, height: height * 0.7, playing: playing, controls: isPresenter, onReady: onReady, onPause: onPause, onPlay: onPlay }) }));
};
_react_refresh_temp_3 = ReactPlayerComponent;
$RefreshReg$(_react_refresh_temp_3, "ReactPlayerComponent");
_react_refresh_temp_4(ReactPlayerComponent, "N6UilOL6TizAEmwfCZIZfbjI/SU=", false, () => [useAppSelector, useAppSelector]);
export default ReactPlayerComponent;
